var map = {
	"./avatar-1.png": 27222,
	"./avatar-10.png": 74752,
	"./avatar-11.png": 65249,
	"./avatar-12.png": 78558,
	"./avatar-2.png": 93355,
	"./avatar-3.png": 99495,
	"./avatar-4.png": 42927,
	"./avatar-5.png": 24434,
	"./avatar-6.png": 51820,
	"./avatar-7.png": 64914,
	"./avatar-8.png": 10462,
	"./avatar-9.png": 1550,
	"./img-user.png": 20889,
	"./profile.png": 60122,
	"./user-round.svg": 32907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5242;